import * as React from "react";
const SvgArrowForward = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 21, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#0076FF", d: "M10.5 3.5 9.27 4.73l4.88 4.9H3.5v1.74h10.65l-4.88 4.9 1.23 1.23 7-7-7-7Z" }));
export default SvgArrowForward;
